import {RWebShare} from 'react-web-share';
import {useUserProfile} from '../requests/use-user-profile';
import {Trans} from '@common/i18n/trans';
import {IoCopyOutline} from 'react-icons/io5';
import {toast} from '@common/ui/toast/toast';
import {useSelectedLocale} from '@common/i18n/selected-locale';
import ReactSpeedometer from 'react-d3-speedometer';
import {Button} from '@common/ui/buttons/button';
import {useNavigate} from '@common/utils/hooks/use-navigate';

function ProfileInviteFriendsPanel() {
  const navigate = useNavigate();

  const {locale} = useSelectedLocale();

  const userQuery = useUserProfile();
  const user = userQuery.data!.user;

  return (
    <div className="flex flex-col items-center">
      <p className="text-lg font-bold">
        {locale.language === 'fa' ? 'دعوت از دوستان' : 'Invite Friends'}
      </p>
      <p
        className="w-2/3 text-justify"
        dir={locale.language === 'fa' ? 'rtl' : 'ltr'}
      >
        {locale.language === 'fa'
          ? ' 🎉 دوستاتو دعوت کن، امتیاز بگیر! با دعوت از دوستانت به MdbMax هم به اون‌ها دنیایی از فیلم و سریال رو معرفی می‌کنی، هم خودت امتیاز ویژه دریافت می‌کنی. هر بار که یکی از دوستانت با لینک دعوتت ثبت‌نام کنه، امتیاز هدیه می‌گیری که از امکانات ویژه سایت استفاده کنی. با هم دیدن فیلم‌ها بیشتر می‌چسبه – پس همین حالا شروع کن! 🍿 '
          : `🎉 Invite your
       friends, earn rewards! By inviting your friends to MdbMax, you’re
       not only sharing a world of movies and series with them — you’re also
       earning bonus points for yourself. Every time someone signs up using
       your invite link, you’ll receive reward points that you can use to
       access to exclusive site features. Watching movies is always more fun together – so start inviting now! 🍿`}
      </p>
      <div className="flex justify-center gap-20">
        <div className="flex items-center gap-2">
          <span>
            <Trans message="Your Refferal Code is :" />
          </span>
          <span>{user.invite_token}</span>
          <IoCopyOutline
            className="cursor-pointer"
            onClick={() => {
              if (user.invite_token) {
                navigator.clipboard.writeText(user.invite_token);
              }
              toast('Copied to clipboard', {type: 'positive'});
            }}
          />
        </div>
        <RWebShare
          data={{
            text: 'Share our website with your friends',
            url: `https://mdbmax.com/register?referal=${user.invite_token}`,
            title: 'Invite Friends',
          }}
          // onClick={() => console.log('shared successfully!')}
        >
          <button>Share 🔗</button>
        </RWebShare>
      </div>
      <div className="mt-20 flex items-center w-2/3">
        <div
          className={`flex w-1/2 flex-col items-center gap-10 ${locale.language === 'fa' ? 'border-l' : 'border-r'}`}
        >
          <span className="font-bold">
            <Trans message="Number of people invited" />
          </span>
          <span className="text-2xl font-bold">{user.invite_count || 0}</span>
        </div>
        <div className="flex w-1/2 flex-col items-center gap-10">
          <span className="text-2xl font-bold">
            <ReactSpeedometer
              forceRender={true}
              ringWidth={10}
              width={150}
              height={100}
              minValue={0}
              value={user?.score && user?.score > 100 ? 100 : user?.score}
              currentValueText={user?.score ? user?.score.toString() : '0'}
              labelFontSize="0"
              maxValue={100}
              segments={1000}
              valueTextFontSize="14px"
              textColor="#fff"
              needleHeightRatio={0.5}
            />
          </span>
          {/* <span className="font-bold">
            <Trans message="Point" />
          </span> */}
        </div>
      </div>
      <Button
        className="mx-auto mt-[50px] w-[200px]"
        variant={'flat'}
        color={'primary'}
        onClick={() => navigate('/pages/friend-invitation-scoring-system')}
      >
        <Trans message="More Info" />
      </Button>
      <div className="">
        <p className="my-[20px] text-center">
          <Trans message="Point History Log" />
        </p>
        <table className="border">
          <tr>
            <th className="border p-[20px] text-center">
              <Trans message="Level" />
            </th>
            <th className="border p-[20px] text-center">
              <Trans message="Score" />
            </th>
            <th className="border p-[20px] text-center">
              <Trans message="Type" />
            </th>
          </tr>
          {user?.score_logs?.map(item => (
            <tr>
              <td className="border p-[20px] text-center">{item.level}</td>
              <td className="border p-[20px] text-center">{item.score}</td>
              <td className="border p-[20px] text-center">
                <Trans message={item.type} />
              </td>
            </tr>
          ))}
        </table>
      </div>
    </div>
  );
}

export default ProfileInviteFriendsPanel;
